import { createReducer } from './../../service/Utils';
import { set } from 'lodash/fp';

const initialState = {
  loginData: {},
  redirectData: {},
  passwordReset: {},
  loadedData: {},
  logoutOptions: {}
};

export default createReducer(initialState, {
  LOGIN: (state, payload = {}) => {
    const prevState = state.loginData;
    if (prevState.tmpCode && payload.resend) {
      delete prevState.tmpCode;
    }
    return {
      ...state,
      loginData: { ...prevState, ...payload }
    };
  },
  PASSWORD_RESET: (state, payload) => {
    return { ...state, passwordReset: payload };
  },
  PASSWORD_SETUP: (state, payload) => {
    return { ...state, passwordSetup: payload };
  },
  LOGOUT: (state, payload) => {
    if (payload) {
      return { ...state, logoutOptions: payload };
    }
    return state;
  },
  SIGN_UP: (state, payload) => {
    return { ...state, loginData: payload };
  },
  REDIRECT: (state, payload) => {
    return { ...state, redirectData: payload };
  },
  REQUEST_USER: (state, payload) => {
    return set(state, payload[0], payload[1]);
  },
  RESET_LOGIN_DATA: () => {
    return initialState;
  }
});
